import { render, staticRenderFns } from "./subpackage.vue?vue&type=template&id=4a3a04a0&scoped=true"
import script from "./subpackage.vue?vue&type=script&lang=js"
export * from "./subpackage.vue?vue&type=script&lang=js"
import style0 from "./subpackage.vue?vue&type=style&index=0&id=4a3a04a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a04a0",
  null
  
)

export default component.exports